import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const DialogBox = ({
  content,
  heading,
  button1,
  button2,
  confirmRequest,
  open,
  hideConfirmation
}) => {
  const handleClose = () => {
    hideConfirmation(true);
  };

  const handleCloseAndConfirm = () => {
    confirmRequest(true);
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{heading}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseAndConfirm}>{button1}</Button>
        <Button onClick={handleClose}>{button2}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogBox;
